let activeVariantId = null;

/* AI1 2026-10-31 PHASE 85.6 (DRAFT ONLY): amounts use the theme's own Liquid `money` format
   (e.g. "485,00 kr", "$41.00", "CHF 35.00"), read from the [data-ai1-money] sample rendered by
   sections/ai1-prestige-header.liquid and sections/ai1-global-assets.liquid, so the drawer and the
   WELCOME10 block match /cart and product cards. withCode=true uses the money_with_currency sample
   (as on the /cart total, e.g. "$190.88 CAD") so "$" amounts are never ambiguous between US/CA/AU.
   If the sample is missing or the currency differs, the previous Intl output below is used unchanged.
   Rollback: delete ai1MoneyFormat() and the first if-block inside ai1Money(). */
var ai1MoneyFmtCache = {};
function ai1MoneyFormat(withCode) {
  var key = withCode ? 'wc' : 'm';
  if (ai1MoneyFmtCache[key] !== undefined) return ai1MoneyFmtCache[key];
  var el = document.querySelector('[data-ai1-money]');
  if (!el) return null; /* not parsed yet: try again on the next call */
  ai1MoneyFmtCache[key] = null;
  try {
    var ta = document.createElement('textarea');
    ta.innerHTML = el.getAttribute(withCode ? 'data-ai1-money-wc' : 'data-ai1-money') || '';
    var s = ta.value, d = 2;
    var m = s.match(/1([^\d]?)234(?:\1)567([^\d])89/); /* sample = 1,234,567.89 */
    if (!m) { m = s.match(/1([^\d]?)234(?:\1)568/); d = 0; }
    if (m) {
      ai1MoneyFmtCache[key] = { cur: el.getAttribute('data-ai1-money-cur'), pre: s.slice(0, m.index),
        suf: s.slice(m.index + m[0].length), th: m[1] || '', dec: d ? m[2] : '', d: d };
    }
  } catch (e) { ai1MoneyFmtCache[key] = null; }
  return ai1MoneyFmtCache[key];
}

function ai1Money(cents, currency, withCode) {
  var f = ai1MoneyFormat(!!withCode);
  if (f && (!currency || currency === f.cur)) {
    var n = Number(cents) || 0, neg = n < 0;
    n = Math.abs(n);
    var v = f.d ? (n / 100).toFixed(2) : String(Math.round(n / 100));
    var parts = v.split('.');
    return (neg ? '-' : '') + f.pre + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.th) +
      (f.d ? f.dec + parts[1] : '') + f.suf;
  }
  var amt = (Number(cents) || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP' }).format(amt);
  } catch (e) {
    return (currency ? currency + ' ' : '£') + amt.toFixed(2);
  }
}

function ai1OpenCart() {
  document.getElementById('p-cd').classList.add('open');
  document.getElementById('p-co').classList.add('open');
  ai1FetchCart();
}

function ai1CloseCart() {
  document.getElementById('p-cd').classList.remove('open');
  document.getElementById('p-co').classList.remove('open');
}

function ai1OpenModal(btn) {
  const title = btn.getAttribute('data-title');
  const price = btn.getAttribute('data-price');
  const img = btn.getAttribute('data-img');
  let variants;
  try {
    variants = JSON.parse(btn.getAttribute('data-vars') || '[]');
    if (!Array.isArray(variants)) throw new Error('bad variants');
  } catch (err) {
    ai1TriggerToast("We couldn't load the options for this item. Please open the product page.", "er");
    return;
  }

  document.getElementById('p-mt-h').innerText = title;
  document.getElementById('p-mp').innerText = price;
  document.getElementById('p-mi').src = img;

  const pillContainer = document.getElementById('p-pills');
  pillContainer.innerHTML = '';
  activeVariantId = null;

  if (variants.length > 0) {
    variants.forEach((v, i) => {
      const pBtn = document.createElement('button');
      pBtn.innerText = v.t;
      pBtn.className = 'p-pill' + (i === 0 ? ' on' : '');
      /* AI1 PHASE 3.31 (DRAFT ONLY): expose selected option to assistive tech. Rollback: delete the aria-pressed lines. */
      pBtn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      if (i === 0) activeVariantId = v.id;
      pBtn.onclick = function () {
        document.querySelectorAll('.p-pill').forEach(p => { p.classList.remove('on'); p.setAttribute('aria-pressed', 'false'); });
        pBtn.classList.add('on');
        pBtn.setAttribute('aria-pressed', 'true');
        activeVariantId = v.id;
      };
      pillContainer.appendChild(pBtn);
    });
  }
  document.getElementById('p-mo').classList.add('open');
}

function ai1CloseModal() {
  document.getElementById('p-mo').classList.remove('open');
}

function ai1ModalOvClick(e) {
  if (e.target.id === 'p-mo') ai1CloseModal();
}

/* ------------------------------------------------------------
   AI1 Phase 3.5 (DRAFT ONLY): shared cart-response helpers.
   Shopify returns HTTP 4xx with {status, message, description} when
   a cart request is rejected (e.g. sold out). Both add and change
   paths use these so success is never reported for a failed request.
   Reversible: restore the pre-change file.
   ------------------------------------------------------------ */
function ai1ReadCartResponse(res) {
  return res.text().then(function (txt) {
    var data = null;
    if (txt) {
      try { data = JSON.parse(txt); } catch (e) { data = null; }
    }
    return { ok: res.ok, data: data };
  });
}

/* Returns null when the response is a genuine success, otherwise a message to show. */
function ai1CartFailure(r, fallback) {
  var d = r.data;
  var isObj = !!d && typeof d === 'object';
  if (r.ok && isObj && !d.status && !d.errors) return null;
  if (isObj) {
    var m = d.description || d.message || (typeof d.errors === 'string' ? d.errors : '');
    if (m) return String(m);
  }
  return r.ok ? "We couldn't confirm that your cart was updated. Please check your cart." : fallback;
}

function ai1AddToCart(variantId, btn) {
  if (!variantId) return;
  /* AI1 PHASE 3.22 (DRAFT ONLY): ignore re-activation (keyboard Enter/Space ignores pointer-events:none) while an add is in flight. Rollback: delete this guard + aria-busy lines. */
  if (btn && btn.classList.contains('ld')) return;
  if (btn) { btn.classList.add('ld'); btn.setAttribute('aria-busy', 'true'); }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(ai1ReadCartResponse)
    .then(function (r) {
      if (btn) { btn.classList.remove('ld'); btn.removeAttribute('aria-busy'); }
      var failure = ai1CartFailure(r, 'This item could not be added to your cart.');
      if (failure) {
        // Keep quick-view open so the shopper can choose another option.
        ai1TriggerToast(failure, "er");
        // If the server said OK but the body was unreadable, resync the badge quietly.
        if (r.ok) ai1FetchCart(true);
        return;
      }
      ai1CloseModal();
      ai1TriggerToast("Success! Item Added", "ok");
      ai1OpenCart();
    })
    .catch(function () {
      if (btn) { btn.classList.remove('ld'); btn.removeAttribute('aria-busy'); }
      ai1TriggerToast("We couldn't add this item. Please check your connection and try again.", "er");
    });
}

function ai1ATC() {
  ai1AddToCart(activeVariantId, document.getElementById('p-atc'));
}

function ai1DirectAdd(variantId, btn) {
  ai1AddToCart(variantId, btn);
}

/* AI1 Phase 3.5 (DRAFT ONLY) R3: announcements go to two persistent live regions that
   exist in the page markup before any message is written (#p-live-status = polite,
   #p-live-alert = assertive). The visible toast (#p-toast) stays for sighted users. */
var ai1ToastTimer;
var ai1AnnounceTimer;
function ai1Announce(msg, status) {
  var isError = status === 'er';
  var target = document.getElementById(isError ? 'p-live-alert' : 'p-live-status');
  var other = document.getElementById(isError ? 'p-live-status' : 'p-live-alert');
  if (other) other.textContent = '';
  if (!target) return;
  target.textContent = '';
  clearTimeout(ai1AnnounceTimer);
  // Short delay so an identical repeated message is announced again.
  ai1AnnounceTimer = setTimeout(function () { target.textContent = msg; }, 60);
}

function ai1TriggerToast(msg, status) {
  const toast = document.getElementById('p-toast');
  if (toast) {
    toast.innerText = msg;
    toast.className = `p-toast sh ${status}`;
    clearTimeout(ai1ToastTimer);
    // Errors stay visible longer so they can be read.
    ai1ToastTimer = setTimeout(() => toast.classList.remove('sh'), status === 'er' ? 6000 : 3000);
  }
  ai1Announce(msg, status);
}

/* ------------------------------------------------------------
   AI1 CART LINE EDITING
   Quantity steppers (+/-) and remove inside the Prestige drawer,
   backed by Shopify's /cart/change.js (1-based line index).
   After every change we re-render via ai1FetchCart() so the
   items, subtotal and badge stay in sync from one source.
   ------------------------------------------------------------ */
var ai1ChangeInFlight = false;
function ai1ChangeLine(line, quantity, btn) {
  // One cart edit at a time: line numbers shift after every change, so a second
  // request fired from a stale line index could hit the wrong item.
  if (ai1ChangeInFlight) return;
  ai1ChangeInFlight = true;
  /* AI1 PHASE 3.34 (DRAFT ONLY): remember which control was used so keyboard focus can return to it after the drawer re-renders. Rollback: delete focusInfo + ai1RestoreFocus. */
  var focusInfo = btn && btn.classList
    ? { cls: btn.classList.contains('p-qi') ? 'p-qi' : (btn.classList.contains('p-qd') ? 'p-qd' : 'p-rm'), line: line }
    : null;
  if (btn) btn.classList.add('ld');
  var drawer = document.getElementById('p-cd');
  if (drawer) drawer.classList.add('p-busy');
  function finish() {
    ai1ChangeInFlight = false;
    if (btn) btn.classList.remove('ld');
    if (drawer) drawer.classList.remove('p-busy');
  }
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(ai1ReadCartResponse)
    .then(function (r) {
      finish();
      var failure = ai1CartFailure(r, 'Your cart could not be updated.');
      if (failure) ai1TriggerToast(failure, "er");
      // Always resync from cart.js; stay quiet if an error was already shown.
      ai1FetchCart(!!failure, focusInfo);
    })
    .catch(function () {
      finish();
      ai1TriggerToast("We couldn't update your cart. Please check your connection and try again.", "er");
      ai1FetchCart(true, focusInfo);
    });
}

function ai1UpdateQty(line, quantity, btn) {
  if (quantity < 0) return;
  ai1ChangeLine(line, quantity, btn);
}

function ai1RemoveItem(line, btn) {
  ai1ChangeLine(line, 0, btn);
}

function ai1InjectCartStyles() {
  if (document.getElementById('ai1-cart-style')) return;
  // Drawer surface is light cream (--c #faf8f5); these controls are tuned for
  // strong contrast on that background, using the Prestige design tokens.
  var css =
    '.p-qty { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 10px; }' +
    '.p-stepper { display: inline-flex; align-items: center; border: 1px solid #b8b0a4; border-radius: 30px; overflow: hidden; background: #fff; }' +
    ".p-stepper button { width: 30px; height: 30px; border: 0; background: transparent; font-size: 16px; line-height: 1; color: #1c1c1c; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background .2s ease, color .2s ease; font-family: 'Jost', sans-serif; }" +
    '.p-stepper button:hover { background: #c8a96e; color: #0e1c35; }' +
    '.p-stepper button:disabled { opacity: .35; cursor: default; }' +
    ".p-qn { min-width: 34px; text-align: center; font-family: 'Jost', sans-serif; font-size: 13px; font-weight: 600; color: #1c1c1c; }" +
    ".p-rm { border: 0; background: transparent; padding: 0; font-family: 'Jost', sans-serif; font-size: 11px; letter-spacing: .1em; text-transform: uppercase; color: #5a4e42; cursor: pointer; text-decoration: underline; text-underline-offset: 3px; transition: color .2s ease; }" +
    '.p-rm:hover { color: #9b2c2c; }' +
    '.p-cd.p-busy .p-ci { opacity: .55; pointer-events: none; transition: opacity .15s ease; }';
  var st = document.createElement('style');
  st.id = 'ai1-cart-style';
  st.textContent = css;
  // Append to <body> so these rules cascade AFTER ai1-prestige.css.
  (document.body || document.head).appendChild(st);
}

/* AI1 Phase 3.5 (DRAFT ONLY) R5: context-specific helpers for cart markup. */
var AI1_BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/* HTML text context. */
function ai1EscText(v) {
  return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/* Double- or single-quoted HTML attribute context. */
function ai1EscAttr(v) {
  return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/* Whole number for use inside inline handlers; never lets cart data inject code. */
function ai1Int(v, fallback) {
  var n = Math.floor(Number(v));
  return isFinite(n) ? n : (fallback || 0);
}

/* Returns the URL only when it is an https image URL, otherwise ''. HTML escaping alone does
   not make a URL safe (javascript:, data: etc.), so the scheme is checked first. */
function ai1SafeImageUrl(u) {
  if (typeof u !== 'string' || !u) return '';
  try {
    var parsed = new URL(u, window.location.origin);
    return parsed.protocol === 'https:' ? u : '';
  } catch (e) {
    return '';
  }
}

/* AI1 PHASE 3.34 (DRAFT ONLY): the drawer markup is rebuilt after every cart change, which drops keyboard focus
   to <body>. Put focus back on the equivalent control (or the close button when the cart is now empty). */
function ai1RestoreFocus(info) {
  if (!info) return;
  var a = document.activeElement;
  if (a && a !== document.body && document.body.contains(a)) return;
  var drawer = document.getElementById('p-cd');
  if (!drawer || !drawer.classList.contains('open')) return;
  var rows = drawer.querySelectorAll('.p-cl');
  var target = null;
  if (rows.length) {
    var row = rows[Math.min(info.line, rows.length) - 1];
    target = row.querySelector('.' + info.cls) || row.querySelector('.p-rm');
  } else {
    target = drawer.querySelector('.p-cx');
  }
  if (target) target.focus();
}

var ai1FetchSeq = 0;
var ai1LastRenderedSeq = 0;
function ai1FetchCart(quiet, focusInfo) {
  ai1InjectCartStyles();
  var seq = ++ai1FetchSeq;
  fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    })
    .then(function (cart) {
      if (!cart || typeof cart !== 'object' || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') {
        throw new Error('invalid cart payload');
      }
      // A newer response has already been drawn: do not overwrite it with older data.
      if (seq < ai1LastRenderedSeq) return;
      ai1LastRenderedSeq = seq;
      const badge = document.getElementById('cart-badge-count');
      if (badge) badge.innerText = cart.item_count;
      const inner = document.getElementById('p-ci');
      const footer = document.getElementById('p-cf');
      if (!inner || !footer) return;

      if (cart.item_count === 0) {
        inner.innerHTML = `<div class="p-ce"><p>Your cart is empty</p></div>`;
        footer.style.display = 'none';
      } else {
        footer.style.display = 'block';
        document.getElementById('p-tot').innerText = ai1Money(cart.total_price, cart.currency, true); /* Phase 85.6: same format as the /cart total */
        let itemsHtml = '';
        cart.items.forEach((item, idx) => {
          const line = idx + 1;
          const qty = ai1Int(item.quantity, 1);
          const title = item.product_title == null ? '' : String(item.product_title);
          const variant = item.variant_title == null ? '' : String(item.variant_title);
          // Product-specific control names (escaped for the quoted attribute).
          const what = ai1EscAttr(variant ? title + ' (' + variant + ')' : title);
          const imgUrl = ai1SafeImageUrl(item.image);
          const imgHtml = imgUrl
            ? `<img src="${ai1EscAttr(imgUrl)}" alt="${ai1EscAttr(title)}">`
            : `<img src="${AI1_BLANK_IMG}" alt="">`;
          itemsHtml += `
          <div class="p-cl">
            ${imgHtml}
            <div class="p-cli">
              <h4>${ai1EscText(title)}</h4>
              <div class="vt">${ai1EscText(variant)}</div>
              <div class="lp">${ai1EscText(ai1Money(item.line_price, cart.currency))}</div>
              <div class="p-qty">
                <div class="p-stepper">
                  <button type="button" class="p-qd" aria-label="Decrease quantity of ${what}" onclick="ai1UpdateQty(${line}, ${qty - 1}, this)">&#8722;</button>
                  <span class="p-qn">${qty}</span>
                  <button type="button" class="p-qi" aria-label="Increase quantity of ${what}" onclick="ai1UpdateQty(${line}, ${qty + 1}, this)">&#43;</button>
                </div>
                <button type="button" class="p-rm" aria-label="Remove ${what} from cart" onclick="ai1RemoveItem(${line}, this)">Remove</button>
              </div>
            </div>
          </div>`;
        });
        inner.innerHTML = itemsHtml;
      }
      ai1RestoreFocus(focusInfo);
    })
    .catch(function () {
      // Leave whatever is on screen untouched: a failed refresh must never look like an empty cart.
      if (!quiet) ai1TriggerToast("We couldn't refresh your cart. Please try again.", "er");
    });
}

function ai1Wish(btn) {
  btn.classList.toggle('on');
  ai1TriggerToast("Wishlist Updated", "ok");
}

document.addEventListener("DOMContentLoaded", function () {
  fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()).then(c => {
    var badge = document.getElementById('cart-badge-count');
    if (badge && c && typeof c.item_count === 'number') badge.innerText = c.item_count;
  }).catch(function () { /* badge keeps its server-rendered value */ });
});

/* AI1 Phase 98g (DRAFT ONLY): Escape closes the cart drawer (keyboard users had no way
   to dismiss it other than tabbing to the close button). Reversible: delete this block. */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var d = document.getElementById('p-cd');
  if (d && d.classList.contains('open')) ai1CloseCart();
});

/* ============================================================
   AI1 SEAMLESS MARQUEE
   Fixes the announcement / ticker bars so they scroll
   continuously from right to left and loop without gaps.
   Root cause of the old "stuck in the middle" behaviour:
   the track held only ONE copy of the items while the CSS
   animated translateX(0 -> -50%). The -50% technique needs
   TWO identical copies inside the track. We clone the items
   here and layer professional Prestige styling on top.
   ============================================================ */
(function () {
  function ai1InjectMarqueeStyles() {
    if (document.getElementById('ai1-marquee-style')) return;
    var css =
      '.p-tick, .p-mq {' +
      '  display: flex; align-items: center; overflow: hidden; position: relative;' +
      '  -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);' +
      '          mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);' +
      '}' +
      '.p-tick { background: #0e1c35; padding: 11px 0; border-top: 1px solid rgba(200,169,110,.16); border-bottom: 1px solid rgba(200,169,110,.16); }' +
      '.p-mq { background: #0e1c35; padding: 24px 0; border-top: 1px solid rgba(200,169,110,.14); border-bottom: 1px solid rgba(200,169,110,.14); }' +
      '.p-tick-t, .p-mq-t {' +
      '  display: flex; flex-wrap: nowrap; flex-shrink: 0; align-items: center;' +
      '  min-width: 100%; white-space: nowrap; will-change: transform;' +
      '}' +
      '.p-tick-t { animation: ai1-marq 40s linear infinite; }' +
      '.p-mq-t { animation: ai1-marq 34s linear infinite; }' +
      '.p-tick:hover .p-tick-t, .p-mq:hover .p-mq-t { animation-play-state: paused; }' +
      '.p-ti {' +
      '  display: inline-flex; align-items: center; border: 0; padding: 0; margin: 0;' +
      "  font-family: 'Jost', sans-serif; font-size: 11px; font-weight: 500;" +
      '  letter-spacing: .22em; text-transform: uppercase; color: rgba(255,255,255,.82); white-space: nowrap;' +
      '}' +
      '.p-dot { display: inline-block; color: #c8a96e; font-size: 9px; margin: 0 34px; opacity: .9; transform: translateY(-.5px); }' +
      '.p-mqi {' +
      '  display: inline-flex; align-items: center; border: 0; padding: 0;' +
      "  font-family: 'Cormorant Garamond', Georgia, serif; font-size: 25px; font-weight: 300;" +
      '  letter-spacing: .04em; color: rgba(255,255,255,.85); white-space: nowrap;' +
      '}' +
      '.p-mqi em { font-style: italic; color: #c8a96e; }' +
      ".p-mqi::after { content: '\\2726'; color: #c8a96e; font-size: 13px; margin: 0 46px; opacity: .85; font-style: normal; }" +
      '@keyframes ai1-marq { from { transform: translateX(0); } to { transform: translateX(-50%); } }' +
      '@media (prefers-reduced-motion: reduce) {' +
      '  .p-tick-t, .p-mq-t { animation: none !important; transform: none !important; }' +
      '}';
    var st = document.createElement('style');
    st.id = 'ai1-marquee-style';
    st.textContent = css;
    // Append to <body> so these rules cascade AFTER ai1-prestige.css
    // (which is loaded inside the section body) without needing !important.
    (document.body || document.head).appendChild(st);
  }

  function ai1InitMarquee() {
    ai1InjectMarqueeStyles();
    var tracks = document.querySelectorAll('.p-tick-t, .p-mq-t');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.getAttribute('data-ai1-marquee') === 'ready') return;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      // Clone the full set once -> two identical copies -> seamless -50% loop.
      items.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.setAttribute('data-ai1-marquee', 'ready');
      // Restart the animation now that the track width has doubled.
      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.animation = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ai1InitMarquee);
  } else {
    ai1InitMarquee();
  }
})();

/* ============================================================
   AI1 PERF HYGIENE (June 2026 speed audit)
   1) Product description / rich-text images come from product
      HTML without width/height and load eagerly even though they
      sit far below the fold. We mark them lazy + async decoding
      so they never compete with the LCP image, and constrain
      them with height:auto to keep layout stable.
   2) The Prestige quick-view modal image (#p-mi) ships with an
      empty src="" placeholder until JS fills it; we swap in a
      1x1 transparent GIF so the markup stays valid and no
      browser attempts a stray request.
   ============================================================ */
(function () {
  var BLANK_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function ai1PerfHygiene() {
    // (1) Below-the-fold rich text images -> lazy + async
    var rteImgs = document.querySelectorAll('.product__description img, .rte img, .p-desc img');
    Array.prototype.forEach.call(rteImgs, function (img) {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
    });

    // (2) Quick-view modal image placeholder
    var mi = document.getElementById('p-mi');
    if (mi && !mi.getAttribute('src')) {
      mi.src = BLANK_GIF;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ai1PerfHygiene);
  } else {
    ai1PerfHygiene();
  }
})();
